/* eslint max-len: off */
import React from 'react';
import {Icon} from '../createSvg';
import {IconProps} from '../types';

export const ArrowPageFirst = (props: IconProps) => (
  <Icon {...props}>
    <path opacity=".87" fill="none" d="M0 0h24v24H0V0z" />
    <path d="M17.7075 15.89L13.8175 12L17.7075 8.11C18.0975 7.72 18.0975 7.09 17.7075 6.7C17.3175 6.31 16.6875 6.31 16.2975 6.7L11.7075 11.29C11.3175 11.68 11.3175 12.31 11.7075 12.7L16.2975 17.3C16.6875 17.69 17.3175 17.69 17.7075 17.3C18.0875 16.91 18.0875 16.27 17.7075 15.89ZM6.9975 18C6.4475 18 5.9975 17.55 5.9975 17L5.9975 7C5.9975 6.45 6.4475 6 6.9975 6C7.5475 6 7.9975 6.45 7.9975 7L7.9975 17C7.9975 17.55 7.5475 18 6.9975 18Z" />
  </Icon>
);
